import buildQuery from './buildQuery'

function buildEndpoint({ route, path, params }) {
  const query = buildQuery(params)
  return `${route}${path ? `/${path}` : ''}${query ? `/?${query}` : ''}`
}

export default buildEndpoint